import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, Leaf, Shield, Heart, Droplet, Ban, Star, ShoppingBagIcon } from 'lucide-react';
// Product data
const bodyCareProducts = [{
  id: 101,
  name: 'Purifying Body Wash',
  price: 'KSh 1,850',
  image: 'https://images.unsplash.com/photo-1608613304899-ea8098577e38?q=80&w=600&auto=format&fit=crop',
  description: "A gentle, sulfate-free body wash that cleanses without stripping the skin's natural oils. Infused with botanical extracts and essential oils to purify and refresh."
}, {
  id: 102,
  name: 'Botanical Nourishing Body Lotion',
  price: 'KSh 2,100',
  image: 'https://images.unsplash.com/photo-1608613304892-dade9ef8e2ac?q=80&w=600&auto=format&fit=crop',
  description: "A lightweight yet deeply hydrating lotion packed with plant-based nutrients and butters to soften, smooth, and restore skin's natural balance."
}, {
  id: 103,
  name: 'Hydrating Natural Lip Balm',
  price: 'KSh 850',
  image: 'https://images.unsplash.com/photo-1625772299848-391b6a87d7b3?q=80&w=600&auto=format&fit=crop',
  description: 'A soothing, nutrient-rich balm that deeply moisturizes and protects lips with natural oils, butters, and botanical extracts.'
}];
const hairCareProducts = [{
  id: 201,
  name: 'Strength and Balance Shampoo',
  price: 'KSh 1,950',
  image: 'https://images.unsplash.com/photo-1585751119414-ef2636f8aede?q=80&w=600&auto=format&fit=crop',
  description: 'A gentle, sulfate-free formula that cleanses while strengthening hair from root to tip, restoring natural balance to the scalp and strands.'
}, {
  id: 202,
  name: 'Nourish and Strengthen Conditioner',
  price: 'KSh 2,050',
  image: 'https://images.unsplash.com/photo-1535585209827-a15fcdbc4c2d?q=80&w=600&auto=format&fit=crop',
  description: 'A rich, plant-powered conditioner that deeply nourishes and repairs damaged hair, leaving it soft, manageable, and naturally vibrant.'
}];
const skinCareProducts = [{
  id: 301,
  name: 'Seaweed Hyaluronic Serum',
  price: 'KSh 3,200',
  image: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?q=80&w=600&auto=format&fit=crop',
  description: 'A potent hydrating serum that combines the power of marine extracts with hyaluronic acid to plump, hydrate, and rejuvenate the skin.'
}, {
  id: 302,
  name: 'Seaweed Glow Face Oil',
  price: 'KSh 2,800',
  image: 'https://images.unsplash.com/photo-1617897903246-719242758050?q=80&w=600&auto=format&fit=crop',
  description: "A lightweight, non-greasy facial oil that delivers essential nutrients and antioxidants to nourish, protect, and enhance skin's natural radiance."
}, {
  id: 303,
  name: 'Seaweed Resurfacing Face Polish',
  price: 'KSh 2,400',
  image: 'https://images.unsplash.com/photo-1601612628452-9e99ced43524?q=80&w=600&auto=format&fit=crop',
  description: 'A gentle yet effective exfoliator that combines fine natural particles with marine enzymes to reveal smoother, brighter, and more refined skin.'
}, {
  id: 304,
  name: 'Seaweed Detox Face Mask',
  price: 'KSh 2,600',
  image: 'https://images.unsplash.com/photo-1596755389378-c31d21fd1273?q=80&w=600&auto=format&fit=crop',
  description: 'A purifying clay mask enriched with seaweed extracts to draw out impurities, minimize pores, and revitalize dull, congested skin.'
}, {
  id: 305,
  name: 'Seaweed Restore Face Cream',
  price: 'KSh 3,400',
  image: 'https://images.unsplash.com/photo-1556229174-5e42a09e40c3?q=80&w=600&auto=format&fit=crop',
  description: 'A luxurious, nutrient-dense moisturizer that harnesses the regenerative power of seaweed to nourish, repair, and protect the skin barrier.'
}, {
  id: 306,
  name: 'Seaweed Gentle Foaming Cleanser',
  price: 'KSh 2,200',
  image: 'https://images.unsplash.com/photo-1556228578-8c89e6adf883?q=80&w=600&auto=format&fit=crop',
  description: "A mild, pH-balanced facial cleanser that effectively removes impurities while preserving skin's natural moisture with marine botanicals."
}];
// Export products for use in SingleRiaProductPage
export const allRiaProducts = [...skinCareProducts, ...bodyCareProducts, ...hairCareProducts];
const RiaSkincare = () => {
  return <div className="bg-[#f8f9f4] min-h-screen w-full" data-id="element-946">
      {/* Hero Section */}
      <div className="relative bg-[#f0f7eb] py-20" data-id="element-947">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-948">
          <div className="max-w-3xl mx-auto text-center" data-id="element-949">
            <Link to="/" className="inline-flex items-center text-[#2e7d32] font-medium mb-8 hover:text-[#1b5e20] transition-colors duration-300" data-id="element-950">
              <ArrowLeftIcon className="mr-2 h-4 w-4" data-id="element-951" />
              Back to Home
            </Link>
            <h1 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-952">
              Ria Skincare
            </h1>
            <div className="w-16 h-1 bg-[#2e7d32] mx-auto mb-6" data-id="element-953"></div>
            <p className="text-gray-600 text-lg" data-id="element-954">
              A Clean Beauty Line by Shiriaka
            </p>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 w-full h-16 bg-white" style={{
        clipPath: 'polygon(0 100%, 100% 0, 100% 100%, 0% 100%)'
      }} data-id="element-955"></div>
      </div>
      {/* Introduction */}
      <section className="py-16 bg-white" data-id="element-956">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-957">
          <div className="max-w-3xl mx-auto" data-id="element-958">
            <p className="text-lg text-gray-600 mb-8" data-id="element-959">
              As the demand for clean, conscious, and effective beauty continues
              to grow, we at Ria Skincare are proud to offer a refreshing
              alternative — one rooted in nature, elevated by science, and
              powered by purpose.
            </p>
            <p className="text-lg text-gray-600 mb-8" data-id="element-960">
              Born under Shiriaka Essential Oils, Ria represents our commitment
              to natural self-care — from radiant skin to strong, healthy hair
              and nourishing body rituals. With every formulation, we aim to
              prove that wellness shouldn't be a luxury — it should be a
              beautiful, everyday standard.
            </p>
          </div>
        </div>
      </section>
      {/* Philosophy Section */}
      <section className="py-16 bg-[#f8f9f4]" data-id="element-961">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-962">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-963">
            <div className="inline-flex items-center px-4 py-2 bg-[#e8f5e9] text-[#2e7d32] text-sm font-medium rounded-full mb-4" data-id="element-964">
              <span data-id="element-965">Our Philosophy</span>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-966">
              Nature First. Always.
            </h2>
            <p className="text-gray-600" data-id="element-967">
              At Ria, plant-based care is at the heart of everything we create.
              From skincare that soothes and restores, to hair care that
              strengthens and revitalizes, each product is thoughtfully crafted
              to support your well-being — without compromise.
            </p>
          </div>
        </div>
      </section>
      {/* Features Section */}
      <section className="py-16 bg-white" data-id="element-968">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-969">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-970">
            <div className="bg-[#f0f7eb] rounded-xl p-8" data-id="element-971">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6" data-id="element-972">
                <Leaf className="h-6 w-6 text-[#2e7d32]" data-id="element-973" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-974">
                Botanical-Powered Formulas
              </h3>
              <p className="text-gray-600" data-id="element-975">
                Harnessing the power of nature, our products are rich in oils,
                butters, plant extracts, and essential oils — ingredients known
                for their efficacy and skin-loving benefits.
              </p>
            </div>
            <div className="bg-[#f0f7eb] rounded-xl p-8" data-id="element-976">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6" data-id="element-977">
                <Shield className="h-6 w-6 text-[#2e7d32]" data-id="element-978" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-979">
                Eco-Conscious by Design
              </h3>
              <p className="text-gray-600" data-id="element-980">
                We prioritize renewable resources, biodegradable formulas, and
                ethical sourcing practices. Our packaging is minimal and
                recyclable, reflecting our care for the planet.
              </p>
            </div>
            <div className="bg-[#f0f7eb] rounded-xl p-8" data-id="element-981">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6" data-id="element-982">
                <Heart className="h-6 w-6 text-[#2e7d32]" data-id="element-983" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-984">
                Gentle on Skin, Potent in Results
              </h3>
              <p className="text-gray-600" data-id="element-985">
                Whether your skin is sensitive, dry, oily, or somewhere in
                between, our products are designed to be kind and non-irritating
                — free from sulfates, parabens, mineral oils, and artificial
                fragrances.
              </p>
            </div>
            <div className="bg-[#f0f7eb] rounded-xl p-8" data-id="element-986">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6" data-id="element-987">
                <Droplet className="h-6 w-6 text-[#2e7d32]" data-id="element-988" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-989">
                Nutrient-Dense Beauty
              </h3>
              <p className="text-gray-600" data-id="element-990">
                Every product in the Ria collection is infused with powerful
                vitamins, antioxidants, and omega-rich oils that nourish,
                hydrate, and protect — leaving your skin and hair visibly
                healthier and naturally glowing.
              </p>
            </div>
            <div className="bg-[#f0f7eb] rounded-xl p-8" data-id="element-991">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6" data-id="element-992">
                <Ban className="h-6 w-6 text-[#2e7d32]" data-id="element-993" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-994">
                No Nasties — Ever
              </h3>
              <p className="text-gray-600" data-id="element-995">
                We believe in transparency. You'll never find harsh chemicals,
                synthetic fillers, or toxins in our range. Just clean
                ingredients, honest formulas, and integrity in every bottle.
              </p>
            </div>
            <div className="bg-[#f0f7eb] rounded-xl p-8" data-id="element-996">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6" data-id="element-997">
                <div className="w-6 h-6 rounded-full bg-[#2e7d32]" data-id="element-998"></div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-999">
                Where Nature Meets Self-Care
              </h3>
              <p className="text-gray-600" data-id="element-1000">
                We don't just sell products — we offer rituals. Whether you're
                cleansing, moisturizing, masking, or treating — you're stepping
                into a sensory moment grounded in plant therapy and clean beauty
                innovation.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Product Collections */}
      <section className="py-16 bg-[#f8f9f4]" data-id="element-1001">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1002">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-1003">
            <div className="inline-flex items-center px-4 py-2 bg-[#e8f5e9] text-[#2e7d32] text-sm font-medium rounded-full mb-4" data-id="element-1004">
              <span data-id="element-1005">Our Collections</span>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1006">
              Discover Our Products
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-1007">
              Explore our range of clean, plant-powered products designed to
              nourish your skin, hair, and body with the finest natural
              ingredients.
            </p>
          </div>
          {/* Skincare Collection */}
          <div className="mb-20" data-id="element-1008">
            <div className="text-center mb-10" data-id="element-1009">
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1010">
                Ria Skincare
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-1011">
                Our signature seaweed-based collection harnesses the power of
                marine botanicals to hydrate, nourish, and revitalize your skin.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1012">
              {skinCareProducts.map((product, index) => <Link key={index} to={`/ria-skincare/product/${product.id}`} className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 group" data-id="element-1013">
                  <div className="aspect-square overflow-hidden bg-[#f0f7eb]" data-id="element-1014">
                    <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" onError={e => {
                  e.currentTarget.src = 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?q=80&w=600&auto=format&fit=crop';
                }} data-id="element-1015" />
                  </div>
                  <div className="p-6" data-id="element-1016">
                    <h4 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1017">
                      {product.name}
                    </h4>
                    <p className="text-[#2e7d32] font-medium mb-3" data-id="element-1018">
                      {product.price}
                    </p>
                    <p className="text-gray-600 text-sm mb-4" data-id="element-1019">
                      {product.description}
                    </p>
                    <div className="flex justify-between items-center" data-id="element-1020">
                      <span className="inline-flex items-center text-sm text-[#2e7d32] font-medium" data-id="element-1021">
                        <Star className="h-4 w-4 mr-1 fill-[#2e7d32]" data-id="element-1022" />
                        Coming Soon
                      </span>
                      <span className="text-[#2e7d32] font-medium flex items-center" data-id="element-1023">
                        View Details
                        <ShoppingBagIcon className="ml-1 h-4 w-4" data-id="element-1024" />
                      </span>
                    </div>
                  </div>
                </Link>)}
            </div>
          </div>
          {/* Body Care Collection */}
          <div className="mb-20" data-id="element-1025">
            <div className="text-center mb-10" data-id="element-1026">
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1027">
                Ria Body Care
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-1028">
                Nourish and protect your body with our botanical-infused
                formulations designed to cleanse, hydrate, and rejuvenate.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1029">
              {bodyCareProducts.map((product, index) => <Link key={index} to={`/ria-skincare/product/${product.id}`} className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 group" data-id="element-1030">
                  <div className="aspect-square overflow-hidden bg-[#f0f7eb]" data-id="element-1031">
                    <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" onError={e => {
                  e.currentTarget.src = 'https://images.unsplash.com/photo-1608613304899-ea8098577e38?q=80&w=600&auto=format&fit=crop';
                }} data-id="element-1032" />
                  </div>
                  <div className="p-6" data-id="element-1033">
                    <h4 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1034">
                      {product.name}
                    </h4>
                    <p className="text-[#2e7d32] font-medium mb-3" data-id="element-1035">
                      {product.price}
                    </p>
                    <p className="text-gray-600 text-sm mb-4" data-id="element-1036">
                      {product.description}
                    </p>
                    <div className="flex justify-between items-center" data-id="element-1037">
                      <span className="inline-flex items-center text-sm text-[#2e7d32] font-medium" data-id="element-1038">
                        <Star className="h-4 w-4 mr-1 fill-[#2e7d32]" data-id="element-1039" />
                        Coming Soon
                      </span>
                      <span className="text-[#2e7d32] font-medium flex items-center" data-id="element-1040">
                        View Details
                        <ShoppingBagIcon className="ml-1 h-4 w-4" data-id="element-1041" />
                      </span>
                    </div>
                  </div>
                </Link>)}
            </div>
          </div>
          {/* Hair Care Collection */}
          <div data-id="element-1042">
            <div className="text-center mb-10" data-id="element-1043">
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1044">
                Ria Hair Care
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-1045">
                Strengthen and revitalize your hair with our plant-powered
                formulas that cleanse, nourish, and protect from root to tip.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-1046">
              {hairCareProducts.map((product, index) => <Link key={index} to={`/ria-skincare/product/${product.id}`} className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 group" data-id="element-1047">
                  <div className="aspect-square overflow-hidden bg-[#f0f7eb]" data-id="element-1048">
                    <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" onError={e => {
                  e.currentTarget.src = 'https://images.unsplash.com/photo-1585751119414-ef2636f8aede?q=80&w=600&auto=format&fit=crop';
                }} data-id="element-1049" />
                  </div>
                  <div className="p-6" data-id="element-1050">
                    <h4 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1051">
                      {product.name}
                    </h4>
                    <p className="text-[#2e7d32] font-medium mb-3" data-id="element-1052">
                      {product.price}
                    </p>
                    <p className="text-gray-600 text-sm mb-4" data-id="element-1053">
                      {product.description}
                    </p>
                    <div className="flex justify-between items-center" data-id="element-1054">
                      <span className="inline-flex items-center text-sm text-[#2e7d32] font-medium" data-id="element-1055">
                        <Star className="h-4 w-4 mr-1 fill-[#2e7d32]" data-id="element-1056" />
                        Coming Soon
                      </span>
                      <span className="text-[#2e7d32] font-medium flex items-center" data-id="element-1057">
                        View Details
                        <ShoppingBagIcon className="ml-1 h-4 w-4" data-id="element-1058" />
                      </span>
                    </div>
                  </div>
                </Link>)}
            </div>
          </div>
        </div>
      </section>
      {/* Experience Section */}
      <section className="py-16 bg-white" data-id="element-1059">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1060">
          <div className="max-w-3xl mx-auto" data-id="element-1061">
            <p className="text-lg text-gray-600 mb-8" data-id="element-1062">
              Backed by years of experience under the Shiriaka brand and
              inspired by your real needs, Ria Skincare is here to help you
              create a more mindful, intentional beauty routine.
            </p>
            <p className="text-lg text-gray-600 mb-8" data-id="element-1063">
              We invite you to explore our range — and experience the difference
              of clean, affordable, and elevated self-care.
            </p>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-[#f8f9f4]" data-id="element-1064">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1065">
          <div className="max-w-4xl mx-auto bg-[#f0f7eb] rounded-2xl p-12 text-center" data-id="element-1066">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1067">
              Discover Clean Beauty
            </h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-1068">
              Experience the power of nature-inspired skincare with Ria's
              botanical formulations.
            </p>
            <button className="inline-flex items-center justify-center px-8 py-3.5 bg-[#2e7d32] text-white font-medium rounded-lg hover:bg-[#1b5e20] transition-colors duration-300" data-id="element-1069">
              Coming Soon
            </button>
          </div>
        </div>
      </section>
    </div>;
};
export default RiaSkincare;